import axios from "axios";

// Create an Axios instance
console.log(process.env.REACT_APP_URL);
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_URL, // Use your environment variable
  headers: {
    "Content-Type": "application/json",
  },
});
// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = JSON.parse(localStorage.getItem("user"));

    if (token?.token) {
      config.headers.Authorization = `Bearer ${token.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized errors (e.g., redirect to login)
      console.error("Unauthorized! Redirecting...");
      // localStorage.removeItem("authToken");
      // window.location.href = "/"; // Redirect to login page
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
